import { Button, CircularProgress, TextField, Tooltip } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import preAuth from '../../../gql/preAuth'
import PreAuthDetailComponent from './components/PreAuthDetailComponent'
import { Formik } from 'formik'
import { Form } from 'formik'
import superAdmin from '../../../gql/superAdmin'
import toast from 'react-hot-toast'

function PreAuthUpdate () {
  const searchRef = useRef(null)
  const [loadingSearch, setLoadingSearch] = useState(false)
  const [updatePreAuth, { data, loading: StatusLoadind, error: StatusErrors }] =
    useMutation(superAdmin.UPDATE_PRE_AUTH)
  const [getPreAuthTransactionDetails, { loading, error, data: detailsData }] =
    useLazyQuery(preAuth.GET_PREAUTH_TRANSACTION_DETAILS)

  const handleSearch = () => {
    if (searchRef.current && searchRef.current.value.trim()) {
      setLoadingSearch(true)
      getPreAuthTransactionDetails({
        variables: { transactionId: searchRef.current.value.trim() }
      }).finally(() => setLoadingSearch(false))
    }
  }
  const initialValues = {
    transaction_id:
      detailsData?.getPreAuthTransaction?.data?.transaction_id || '',
    outcome: detailsData?.getPreAuthTransaction?.data?.outcome || '',
    disposition: detailsData?.getPreAuthTransaction?.data?.disposition || '',
    items:
      detailsData?.getPreAuthTransaction?.data?.items?.map(item => ({
        id: item.id,
        status: item.status,
        ...(item?.status === 'rejected' && {
          reject_reason_code: item?.reject_reason_code,
          reject_reason_display: item?.reject_reason_display
        })
      })) || []
  }
  const onSubmit = async (values, { resetForm }) => {
    const FilterItems = values?.items?.map(item => {
      if (item.status === 'rejected') {
        return {
          id: item.id,
          status: item.status,
          reject_reason_code: item?.reject_reason_code || '',
          reject_reason_display: item?.reject_reason_display || ''
        }
      } else {
        return {
          id: item.id,
          status: item.status,
          reject_reason_code: '',
          reject_reason_display: ''
        }
      }
    })

    const updatedData = {
      input: {
        transaction_id:
          detailsData?.getPreAuthTransaction?.data?.transaction_id,
        outcome: values.outcome,
        disposition: values.disposition,
        items: FilterItems
      }
    }
    if (!updatedData.input?.transaction_id) {
      toast.error('Transaction ID is missing.')
      return
    }
    try {
      const response = await updatePreAuth({
        variables: updatedData
      })
      if (response?.data?.updatePreAuthStatus?.message) {
        toast.success(response?.data?.updatePreAuthStatus?.message)
        resetForm()
      } else {
        toast.error(` ${StatusErrors?.message || 'Unknown error'}`)
      }
    } catch (error) {
      console.error('Error updating pre-authorization:', error)
    }
  }

  return (
    <div class='eligibility_container'>
      <div class='eligibility-page'>
        <div class='flex justify-between flex-col lg:flex-row gap-4 mb-3 px-3'>
          <div className=''>
            <Tooltip
              placement='right'
              title='Pre Auth Updation'
              className='my-auto !mt-2'
            >
              <span className='font-semibold text-black/70 text-lg '>
                Pre Auth Update
              </span>
            </Tooltip>
          </div>
          <div class=' flex gap-1 flex-col md:flex-row'>
            <div className='relative rounded-md shadow-sm'>
              <input
                ref={searchRef}
                type='text'
                name='search'
                id='search'
                className='block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:!ring-primary sm:text-sm sm:leading-6'
                placeholder={'Search PreAuth'}
              />
            </div>
            <Button
              variant='outlined'
              size='small'
              className='!border-primary !text-primary hover:!bg-primary/10'
              onClick={handleSearch}
              disabled={loadingSearch}
            >
              {loadingSearch ? (
                <CircularProgress className='!text-primary' size={24} />
              ) : (
                <>Search</>
              )}
            </Button>
          </div>
        </div>
      </div>
      <div>
        <Formik onSubmit={onSubmit} initialValues={initialValues}>
          {formik => (
            <Form>
              {detailsData ? (
                <>
                  <PreAuthDetailComponent detailsData={detailsData} />
                  <div className='my-5 flex justify-end items-center'>
                    <Button
                      variant='outlined'
                      type='submit'
                      size='small'
                      className='!border-primary !bg-primary !text-white hover:!text-primary !min-w-[200px] hover:!bg-primary/10'
                    >
                      Submit
                    </Button>
                  </div>
                </>
              ) : (
                <div className='flex justify-center'>
                  <span className='text-gray-400'>No Data Found</span>
                </div>
              )}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default PreAuthUpdate
